import { Grid, Stack, Typography } from "@mui/material";
import { quotationBusiness } from "api/bussiness/quotation/quotation-bussiness";
import { QuotationsPermission } from "commons/enum/permission";
import { dateTimeDisplay } from "commons/ultilities/date/dayjs";
import { observer } from "mobx-react-lite";
import { useStores } from "mobx-stores/_root-store";
import { CustomerDealingAndActiveInfo } from "pages/common/customer-dealing-and-active-info";
import { useCallback, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { PropertyInfo } from "share-components/atomics/property-info";
import {
  EditButton,
  GoBackIconButton,
  PrintPreviewButton,
  RemoveButton,
} from "share-components/mui-wrap/button/action-button";
import { PageContentScrollableContainer } from "share-components/templates/page/page-content-container";
import { PageDetailContainer } from "share-components/templates/page/page-detail-container";
import { PageHeaderContainer } from "share-components/templates/page/page-header-container";
import { EditQuotation } from "../edit-quotation/edit-quotation";
import { QuotationItemTable } from "./quotation-item-table";
import { QuotationPrintPreview } from "./quotation-print-preview";
export const QuotationDetail = observer(() => {
  const { quotationId } = useParams();
  const {
    quotationManagement: { getQuotationDetail, openEdit, openPrintPreview },
  } = useStores();
  useEffect(() => {
    if (quotationId) {
      getQuotationDetail(quotationId);
    }
  }, [getQuotationDetail, quotationId]);
  return (
    <PageDetailContainer>
      <PageHeaderContainer direction={"row"} justifyContent={"space-between"}>
        <Header></Header>
      </PageHeaderContainer>
      <PageContentScrollableContainer>
        <Content></Content>
      </PageContentScrollableContainer>

      <>
        {openEdit && <EditQuotation></EditQuotation>}
        {openPrintPreview && <QuotationPrintPreview />}
      </>
    </PageDetailContainer>
  );
});
type HeaderProps = {};
const Header = observer((props: HeaderProps) => {
  const {
    quotationManagement: {
      quotationDetail,
      setProp: setQuotationManagementProp,
    },
    deleteConfirmationStore: { setProp, setDeletionCallback },
  } = useStores();
  const navigate = useNavigate();
  const goBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);
  const onDelete = useCallback(
    async (id: string) => {
      if (id) {
        await quotationBusiness.delete(id);
        goBack();
      }
    },
    [goBack]
  );
  const removeHandler = useCallback(() => {
    setProp("open", true);
    setDeletionCallback(() => {
      if (!quotationDetail?.id) return;
      onDelete(quotationDetail?.id);
    });
  }, [quotationDetail, onDelete, setDeletionCallback, setProp]);

  const editHandler = useCallback(() => {
    setQuotationManagementProp("openEdit", true);
  }, [setQuotationManagementProp]);

  const openPrintPreviewHandler = useCallback(() => {
    setQuotationManagementProp("openPrintPreview", true);
  }, [setQuotationManagementProp]);

  return (
    <>
      <Stack
        direction={"row"}
        justifyItems={"center"}
        spacing={1}
        alignItems={"center"}
      >
        <GoBackIconButton onClick={goBack}></GoBackIconButton>
        <Typography variant="subtitle2">{`Thông tin chi tiết `}</Typography>
      </Stack>
      <Stack direction={"row"} justifyItems={"center"} spacing={1}>
        <PrintPreviewButton
          accessPermission={[QuotationsPermission.Print]}
          onClick={openPrintPreviewHandler}
        >
          In báo giá
        </PrintPreviewButton>
        <RemoveButton
          accessPermission={[QuotationsPermission.Delete]}
          onClick={removeHandler}
        ></RemoveButton>
        <EditButton
          accessPermission={[QuotationsPermission.Update]}
          onClick={editHandler}
        ></EditButton>
      </Stack>
    </>
  );
});

const Content = observer(() => {
  const {
    quotationManagement: { quotationDetail },
  } = useStores();
  return (
    <Stack>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <PropertyInfo
            title="Ngày:"
            value={dateTimeDisplay(quotationDetail?.date || "")}
          ></PropertyInfo>
        </Grid>

        <Grid item xs={6}>
          <PropertyInfo
            title="Số:"
            value={quotationDetail?.number || ""}
          ></PropertyInfo>
        </Grid>

        <Grid item xs={12}>
          <PropertyInfo
            title="Tên giao dịch:"
            value={
              quotationDetail?.customer ? (
                <CustomerDealingAndActiveInfo
                  customer={quotationDetail?.customer}
                ></CustomerDealingAndActiveInfo>
              ) : (
                ""
              )
            }
          ></PropertyInfo>
        </Grid>

        <Grid item xs={12}>
          <PropertyInfo
            title="Địa chỉ trụ sở:"
            value={quotationDetail?.customer?.headOfficeAddress || ""}
          ></PropertyInfo>
        </Grid>

        <Grid item xs={6}>
          <PropertyInfo
            title="Địa chỉ giao hàng:"
            value={quotationDetail?.deliveryAddress?.address || ""}
          ></PropertyInfo>
        </Grid>

        <Grid item xs={6}>
          <PropertyInfo
            title="Người nhận:"
            value={quotationDetail?.receiverInfo || ""}
          ></PropertyInfo>
        </Grid>

        <Grid item xs={6}>
          <PropertyInfo
            title="Ghi chú:"
            value={quotationDetail?.note || ""}
          ></PropertyInfo>
        </Grid>
      </Grid>
      <Stack sx={{ marginTop: "20px" }} spacing={1}>
        <Typography variant="subtitle2" marginTop={"20px"}>
          Chi tiết mặt hàng
        </Typography>
        <QuotationItemTable></QuotationItemTable>
      </Stack>
    </Stack>
  );
});
